import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "cpp-modal-container no-scroll" }
const _hoisted_2 = { class: "modal-title" }
const _hoisted_3 = { class: "top" }
const _hoisted_4 = { class: "button-container" }

import { computed, onMounted, onUnmounted, reactive, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { toast } from "vue3-toastify";
import CppStructureItem from "@/modules/cpp/components/CppStructureItem.vue";
import UIButton from "@/modules/UI-kit/UIButton.vue";
import UIText from "@/modules/UI-kit/UIText.vue";
import $api from "@/api";
import {
  createBuilding,
  getCreateBuildingForm,
} from "@/modules/buildings/services/buildings.services";

interface IEvent {
  key: string;
  value: string;
}

interface DeleteEvent {
  file: File;
  key: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateBuildingModal',
  setup(__props) {

const spotId = localStorage.getItem("spotId");

const store = useStore();
const route = useRoute();

const variables = reactive({});
const files = ref<IEvent[]>([]);
const isLoading = ref<boolean>(false);
const structure = ref([]);

const isNewBuilding = computed(
  () => !store.state.buildingsStore.currentBuilding?.structure
);

const structureItems = computed(() =>
  isNewBuilding.value
    ? structure.value
    : store.state.buildingsStore.currentBuilding?.structure
);

const modalTitle = computed(() =>
  isNewBuilding.value ? "Новое помещение" : "Помещение"
);

const buttonTitle = computed(() =>
  isNewBuilding.value ? "Создать помещение" : "Редактировать помещение"
);

const role = computed(() => store.state.authStore.role);

// file handlers
const onFileHandler = (event: IEvent) => {
  files.value.push(event);
};

const onFileDelete = (event: DeleteEvent) => {
  files.value = files.value.filter(
    (file) => file.key !== event.key || file.name === event.file.name
  );
};

const onMultiplyFiles = (event: IEvent) => {
  const newFiles = event.value.map((item) => ({
    value: item.file,
    key: event.key,
    name: item.name,
  }));

  newFiles.forEach((file: File) => {
    files.value.push(file);
  });
};

// value handlers
const onInputHandler = (event: IEvent) => {
  variables[event.key] = event.value;
};

const onRadioHandler = (event: IEvent) => {
  variables[event.key] = event.value;
};

const onDatePickerHandler = (event: IEvent) => {
  variables[event.key] = event.value;
};

const onDropDown = (event: any) => {
  variables[event.key] = event.value.value;
};

const generateFormDataBody = () => {
  const formData = new FormData();

  for (const fileObject of files.value) {
    formData.append(fileObject.key, fileObject.value);
  }

  for (const key of Object.keys(variables)) {
    formData.append(key, variables[key]);
  }

  return formData;
};

const create = async () => {
  const formData = generateFormDataBody();

  try {
    await createBuilding(
      role.value,
      route.params.id as string,
      spotId as string,
      formData
    );

    store.commit("modalsStore/closeModal");
    await store.dispatch("buildingsStore/fetchBuildings", {
      partnerId: route.params?.id,
      role: role.value,
      spotId,
    });

    const toastText = !isNewBuilding.value
      ? "Помещение успешно обновлено"
      : "Помещение успешно создано";
    toast.success(toastText);
  } catch {
    toast.error("Не удалось создать помещение");
  }
};

const fetchStructure = async () => {
  try {
    const response = await getCreateBuildingForm(role.value);
    structure.value = [...response.data];
  } catch {
    return null;
  }
};

onMounted(async () => await fetchStructure());
onUnmounted(() => {
  structure.value = [];
  store.commit("buildingsStore/clearCurrentBuilding");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(modalTitle.value), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(structureItems.value, (item, index) => {
        return (_openBlock(), _createBlock(CppStructureItem, {
          class: "structure-item",
          "structure-index": +index,
          item: item,
          key: index,
          fields: item.fields,
          "onUpdate:textValue": onInputHandler,
          "onUpdate:radioValue": onRadioHandler,
          "onUpdate:datePickerValue": onDatePickerHandler,
          "onUpdate:addFile": onFileHandler,
          "onUpdate:dropDown": onDropDown,
          "onUpdate:deleteFile": onFileDelete,
          "onUpdate:multipleFiles": onMultiplyFiles
        }, null, 8, ["structure-index", "item", "fields"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(UIButton, {
        "is-loading": isLoading.value,
        "is-disabled": !isNewBuilding.value,
        onClick: create
      }, {
        default: _withCtx(() => [
          _createVNode(UIText, {
            color: "white",
            "font-family": "proxima-nova-semibold"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(buttonTitle.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-loading", "is-disabled"])
    ])
  ]))
}
}

})